import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const VisaCardIcon = (props: IconProps) => (
  <StyledIcon
    width="56"
    height="18"
    viewBox="0 0 56 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5094_31574)">
      <path
        d="M36.4865 0C32.5154 0 28.9501 2.05412 28.9501 5.82353C28.9501 10.1647 35.2482 10.4612 35.2482 12.6212C35.2482 13.5318 34.1807 14.3576 32.3873 14.3576C29.8254 14.3576 27.9039 13.2141 27.9039 13.2141L27.0926 17.0259C27.0926 17.0259 29.2917 18 32.2379 18C36.5932 18 40.0091 15.8612 40.0091 12.0071C40.0091 7.43294 33.6897 7.13647 33.6897 5.12471C33.6897 4.40471 34.565 3.62118 36.3584 3.62118C38.3866 3.62118 40.0518 4.44706 40.0518 4.44706L40.8631 0.762353C40.8418 0.762353 39.0271 0 36.4865 0ZM0.106748 0.275294L0 0.825882C0 0.825882 1.66527 1.12235 3.18109 1.73647C5.1239 2.43529 5.252 2.83765 5.5936 4.08706L9.15898 17.7035H13.9413L21.2642 0.275294H16.5032L11.785 12.1341L9.86351 2.07529C9.69272 0.931765 8.79603 0.275294 7.68586 0.275294H0.106748ZM23.1857 0.275294L19.4495 17.7035H23.997L27.7118 0.275294H23.1857ZM48.5063 0.275294C47.4175 0.275294 46.841 0.847059 46.414 1.86353L39.753 17.7035H44.5139L45.4319 15.0565H51.239L51.7941 17.7035H56L52.3492 0.275294H48.5063ZM49.1254 4.99765L50.5345 11.5412H46.7556L49.1254 4.99765Z"
        fill="#1434CB"
      />
    </g>
    <defs>
      <clipPath id="clip0_5094_31574">
        <rect width="56" height="18" fill="white" />
      </clipPath>
    </defs>
  </StyledIcon>
)
